// extracted by mini-css-extract-plugin
module.exports = {"root":"WhatGet_root__XOm6m","root_title":"WhatGet_root_title__KQqBj","root_cards":"WhatGet_root_cards__izmlz","root_cards_item":"WhatGet_root_cards_item__gFOL8"};